export function fmtDate(str) {
  if (!str) return '—'
  const d = new Date(str + 'T00:00:00')
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export function diffDays(str) {
  if (!str) return null
  const today = new Date(); today.setHours(0,0,0,0)
  const d = new Date(str + 'T00:00:00')
  return Math.ceil((d - today) / 86400000)
}

export function dateStatus(dateStr, done) {
  if (!dateStr) return 'empty'
  if (done) return 'done'
  const diff = diffDays(dateStr)
  if (diff < 0) return 'overdue'
  if (diff <= 15) return 'soon'
  if (diff <= 30) return 'upcoming'
  return 'ok'
}

export const STATUS_CFG = {
  done:     { bg: '#d1fae5', text: '#065f46', border: '#6ee7b7', label: 'Realizado' },
  overdue:  { bg: '#fee2e2', text: '#7f1d1d', border: '#fca5a5', label: 'Atrasado'  },
  soon:     { bg: '#fef9c3', text: '#713f12', border: '#fde047', label: '≤15 dias'  },
  upcoming: { bg: '#ffedd5', text: '#7c2d12', border: '#fdba74', label: '≤30 dias'  },
  ok:       { bg: '#f0fdf4', text: '#14532d', border: '#86efac', label: 'No prazo'  },
  empty:    { bg: '#f8fafc', text: '#94a3b8', border: '#e2e8f0', label: '—'         },
}

// ACTIVITIES agora é carregado da API via /api/activities
// Mantido como fallback para evitar tela em branco durante o carregamento
export const ACTIVITIES_FALLBACK = [
  { key: 'plantio_verao',      label: 'Plantio Verão'      },
  { key: 'dessecacao_inverno', label: 'Dessecação Inverno' },
  { key: 'plantio_inverno',    label: 'Plantio Inverno'    },
  { key: 'possivel_liberacao', label: 'Poss. Liberação'    },
  { key: 'dessecacao_milho',   label: 'Dessecação Milho'   },
  { key: 'plantio_milho',      label: 'Plantio Milho'      },
]
